// Adjust to values from sass/variables-site/_structure.scss
const oneColumnQuery = window.matchMedia('(max-width: 43.75em)');
const twoColumnsQuery = window.matchMedia(
	'(min-width: 43.75em) and (max-width: 64em)',
);
const threeColumnsQuery = window.matchMedia('(min-width: 64em)');

function initProjects() {
	// Fallback for Safari
	if ('addEventListener' in twoColumnsQuery) {
		twoColumnsQuery.addEventListener('change', updateColumnsCount);
		threeColumnsQuery.addEventListener('change', updateColumnsCount);
	} else {
		twoColumnsQuery.addListener(updateColumnsCount);
		threeColumnsQuery.addListener(updateColumnsCount);
	}

	updateColumnsCount();

	for (const projectsContainer of document.querySelectorAll('.projects')) {
		projectsContainer.addEventListener('click', handleToggleClick);
	}

	for (const projectTeaser of document.querySelectorAll('.project-teaser')) {
		const colorVariation = Math.floor(Math.random() * 3) + 1; // 1-3
		projectTeaser.classList.add(`project-teaser--color-${colorVariation}`);
	}
}

initProjects();

function updateColumnsCount() {
	// eslint-disable-next-line no-restricted-syntax
	for (const projectsContainer of document.querySelectorAll('.projects')) {
		const columnsCount = getColumnsCount();
		if (!columnsCount) {
			return;
		}

		// Prevent repetition if two queries change. Currently, the only
		// usage of dataset.columnsCount
		if (columnsCount === parseInt(projectsContainer.dataset.columnsCount)) {
			continue;
		}

		projectsContainer.dataset.columnsCount = `${columnsCount}`;

		// Move open project to new position
		const openProject = projectsContainer.querySelector(
			'.project-teaser--expanded',
		);

		if (openProject) {
			displayProject(
				parseInt(openProject.dataset.teaserCount),
				projectsContainer,
			);
		}
	}
}

function getColumnsCount() {
	if (threeColumnsQuery.matches) {
		return 3;
	}
	if (twoColumnsQuery.matches) {
		return 2;
	}
	if (oneColumnQuery.matches) {
		return 1;
	}
	/*  Check for falsy return value to prevent in between states caused by
	em sizes */
	return 0;
}

function handleToggleClick(e) {
	const projectsContainer = e.currentTarget;

	// Check for close button click inside of open project
	const closeButton = e.target.closest('.project .project-button');
	if (closeButton) {
		const openTeaser = projectsContainer.querySelector(
			'.project-teaser--expanded',
		);
		hideProject(projectsContainer);
		closeAllTeasers(projectsContainer);

		if (openTeaser && 'scrollIntoView' in openTeaser) {
			openTeaser.scrollIntoView();
		}

		if (openTeaser) {
			openTeaser.querySelector('.project-button').focus();
		}

		return;
	}

	// Listen to clicks on the whole teaser, not only the button
	const teaser = e.target.closest('.project-teaser');
	if (!teaser) {
		return;
	}

	if (teaser.classList.contains('project-teaser--expanded')) {
		closeAllTeasers(projectsContainer);
		hideProject(projectsContainer);
	} else {
		closeAllTeasers(projectsContainer);
		teaser.classList.add('project-teaser--expanded');
		displayProject(teaser, projectsContainer);
	}
}

function displayProject(teaser, projectsContainer) {
	const teaserCount = parseInt(teaser.dataset.teaserCount);
	const insertPosition = getInsertPosition(teaserCount);
	const projectHtml = projectsContainer.querySelector(
		`.projects__articles > :nth-child(${teaserCount})`,
	)?.innerHTML;
	if (!projectHtml) {
		return;
	}
	const expandedProjectContainer =
		projectsContainer.querySelector('.projects__project');
	expandedProjectContainer.innerHTML = projectHtml;

	const insertAfterElement =
		projectsContainer.querySelector(`li:nth-of-type(${insertPosition - 1})`) ||
		projectsContainer.querySelector(`li:nth-last-of-type(1)`);

	insertAfterElement.insertAdjacentElement(
		'afterend',
		expandedProjectContainer,
	);
	expandedProjectContainer.hidden = false;

	// Buggy behaviour if teaser.scrollIntoView() is called directly. Also, smooth
	// scrolling is not working properly.
	window.requestAnimationFrame(() => {
		if ('scrollIntoView' in teaser) {
			teaser.scrollIntoView();
		}
	});

	expandedProjectContainer.focus();
}

function hideProject(projectsContainer) {
	// eslint-disable-next-line no-param-reassign
	projectsContainer.querySelector('.projects__project').hidden = true;
}

function closeAllTeasers(projectsContainer) {
	for (const teaser of projectsContainer.querySelectorAll(
		'.project-teaser--expanded',
	)) {
		teaser.classList.remove('project-teaser--expanded');
	}
}

function getInsertPosition(teaserCount) {
	const columnsCount = getColumnsCount();

	if (columnsCount === 2) {
		return teaserCount + 1 + (teaserCount % 2);
	}

	if (columnsCount === 3) {
		const addValues = [1, 3, 2];
		return teaserCount + addValues[teaserCount % 3];
	}
	// Single column
	return teaserCount + 1;
}
